import React from 'react';
import { DeleteIcon, TagContainer, TagText } from './styled.tags';
import { Close } from '../../icons/Close';
import { TagProps } from '../../../@types/tag';

export function Tags ({ text, onDelete, disabled = false }: TagProps) {
  return (
    <TagContainer data-testid="tags">
      <TagText data-testid="tags-title">{text}</TagText>
      {!disabled && (
        <DeleteIcon data-testid="tags-delete-tag" onClick={onDelete}>
          <Close />
        </DeleteIcon>
      )}
    </TagContainer>
  );
}
